<header class="topbar">
  <div class="left">
    <div class="brand" (click)="router.navigateByUrl('/')">
      <div class="logo">CIG</div>
      <div class="name">{{ 'COMMON.APP_NAME' | translate }}</div>
    </div>
  </div>

  <div class="center"></div>

  <div class="right" *ngIf="!isAuthenticated">
    <button class="secondary lang-btn" (click)="switchLang()" [pTooltip]="'HEADER.LANGUAGE' | translate">
      <i class="pi pi-language"></i>
      <span>{{ lang.current === 'ar' ? ('HEADER.EN' | translate) : ('HEADER.AR' | translate) }}</span>
    </button>
    <button class="primary" (click)="router.navigateByUrl('/login')">
      <i class="pi pi-sign-in"></i>
      <span>{{ 'HEADER.SIGN_IN' | translate }}</span>
    </button>
  </div>

  <div class="right menu-actions" *ngIf="isAuthenticated">
    <div class="user-chip" (click)="router.navigateByUrl('/profile')" [pTooltip]="displayName">
      <div class="avatar">
        <img
          *ngIf="me?.employeeImageUrl && !imageBroken; else initialsTpl"
          [src]="me?.employeeImageUrl"
          (error)="onImageError()"
          alt="avatar"
        />
        <ng-template #initialsTpl>
          <span class="initials">{{ initials }}</span>
        </ng-template>
      </div>
      <span class="user-name">{{ displayName }}</span>
    </div>
    <button class="secondary lang-btn" (click)="switchLang()" [pTooltip]="'HEADER.LANGUAGE' | translate">
      <i class="pi pi-language"></i>
      <span>{{ lang.current === 'ar' ? ('HEADER.EN' | translate) : ('HEADER.AR' | translate) }}</span>
    </button>
    <button class="secondary" (click)="router.navigateByUrl('/admin')" [pTooltip]="'HEADER.ADMIN_PANEL' | translate">
      <i class="pi pi-cog"></i>
      <span>{{ 'HEADER.ADMIN_PANEL' | translate }}</span>
    </button>
    <button class="secondary" (click)="router.navigateByUrl('/sessions')" [pTooltip]="'HEADER.MY_SESSIONS' | translate">
      <i class="pi pi-clock"></i>
      <span>{{ 'HEADER.MY_SESSIONS' | translate }}</span>
    </button>
    <button class="warning" (click)="router.navigateByUrl('/change-password')" [pTooltip]="'NAV.CHANGE_PASSWORD' | translate">
      <i class="pi pi-key"></i>
      <span>{{ 'NAV.CHANGE_PASSWORD' | translate }}</span>
    </button>
    <button class="danger" (click)="logout()" [pTooltip]="'NAV.SIGN_OUT' | translate">
      <i class="pi pi-sign-out"></i>
      <span>{{ 'HEADER.LOGOUT' | translate }}</span>
    </button>
  </div>
</header>
